import type {PointT} from '@freckle/educator-entities/ts/math/common/logic/equation'

export const formatPoint = ({x, y}: PointT): string => `(${x}, ${y})`

export function formatPoints(points: Array<PointT>, separator: string = '\n'): string {
  return points.map(formatPoint).join(separator)
}
